import React from 'react';
import classNames from 'classnames';
import * as Render from '../../platformui/Base/Render';
import { TeaserItemLink } from '../../platformui/Teaser';

const Teaser = (props) => {
  const isStartPage = props.CurrentPageProps.PageTypeName === 'StartPage';

  const isSurveyBlock =
    props.CurrentPageProps.Content.RelatedContent && props.CurrentPageProps.Content.RelatedContent.filter(
      (i) => i.BlockTypeName === 'SurveyBlock' && i
    ).length > 0;

  const columns = classNames({
    columns: true,
    hide:
      props.index >= 4 || (isStartPage && isSurveyBlock && props.index >= 3),
    'medium-6 large-3': props.length > 3,
    'medium-6 large-4':
      (props.length >= 3 && isSurveyBlock) || props.length === 3,
    'medium-12 large-4': props.length === 3 && props.index === 2,
    'medium-6 large-6': props.length === 2,
    'small-12': props.length === 1,
  });

  return (
    <TeaserItemLink
      Title={props.Heading}
      Preamble={props.Description}
      Url={props.Href}
      className={columns}
    />
  );
};

const NewsPush = (props) => {
  return (
    props.Content.ThemeContent != null && (
      <div className="c-news-push">
        {props.Content.ThemeHeading && (
          <h2 className="show-for-sr">{props.Content.ThemeHeading}</h2>
        )}
        <ul className="c-teaser-outer">
          <Render.Block
            blocks={props.Content.ThemeContent}
            propertyName="ThemeContent"
            currentPageProps={props}
          >
            <Teaser length={props.Content.ThemeContent.length} />
          </Render.Block>
        </ul>
      </div>
    )
  );
};

export default NewsPush;